import {SagaIterator} from 'redux-saga';
import {put, select, takeLatest} from 'redux-saga/effects';

import {STEPS} from 'desktop/pages/checkout/constants/checkout';

import {StatusType} from 'desktop/types/statusType';
import {ActionType} from 'types/reducers';

import {setDefaultStateForCompleteOrder} from '../../actions/completeOrder/completeOrder';
import {setCheckoutStep} from '../../reducers/currentStep/currentStep';
import {startSetCheckoutStepSaga} from '../../reducers/sagaStep/sagaStep';
import {changeStepStatus, saveStepStatus} from '../../reducers/status/status';
import {getAllStepsStatuses, getCurrentStep} from '../../selectors/currentStep/currentStep';

/**
 * Set checkout step
 * @param {ActionType<STEPS>} action - Current action
 */
function* setCheckoutStepSaga({payload = STEPS.DELIVERY_STEP}: ActionType<STEPS>): SagaIterator {
    const currentStep = yield select(getCurrentStep);
    const stepsStatuses = yield select(getAllStepsStatuses);
    const currentStepStatus = stepsStatuses[payload];

    if (currentStepStatus && currentStepStatus.editing && currentStep !== STEPS.PAYMENT_STEP) {
        yield put(
            saveStepStatus({
                [currentStep]: {
                    completed: currentStepStatus.editing,
                    editing: false,
                    loaded: stepsStatuses[currentStep].loaded,
                },
            }),
        );
    }

    yield put(setCheckoutStep(payload));
}

/**
 * Change step status
 * @param {ActionType<string>} action - Current action
 */
function* changeStepStatusSaga(action: ActionType<StatusType>) {
    const stepsStatuses: StatusType = yield select(getAllStepsStatuses);
    const stepsUpdates = action.payload || {};

    const result: StatusType = {};

    Object.keys(stepsUpdates as StatusType).forEach((update: string) => {
        const {completed: stepIsCompleted, editing: stepIsOnEditingMode} = stepsStatuses[update];
        result[update] = {
            ...stepsStatuses[update],
            ...stepsUpdates[update],
            editing: stepIsCompleted && !stepIsOnEditingMode,
        };
    });

    yield put(saveStepStatus(result));
    yield put(setDefaultStateForCompleteOrder(result));
}

/**
 * Checkout saga
 */
export function* checkoutSaga(): SagaIterator {
    yield takeLatest(`${changeStepStatus}`, changeStepStatusSaga);
    yield takeLatest(`${startSetCheckoutStepSaga}`, setCheckoutStepSaga);
}
